<template>
    <div>
        <template v-for="(content, i) in componentItem.content">
            
            <div :key="`${i}image-and-body-copy${index}`" style="">
            <div>
                <div v-if="typeof content !== 'object'"  >

                    <div class="form-group">
                        
                        <label>{{ i }}</label>
                        <input type="text" class="form-control" :id="`${i}image-and-body-copy${index}`" v-model="componentItem.content[i]">
                    </div>

                </div>
            </div>
               
            <div v-if="i === 'content'" >
                <div class="form-group edit">
                    <label>{{ i }}</label>	
                    <template v-if="getContentTemplate != null">
                        <Repeater
                        :itemArray="componentItem.content"
                        :itemField="i"
                        :template="getContentTemplate.content.content[0]"
                        :forTemplate="componentItem.template"
                        />
                    </template>
                </div>
            </div>

            <div v-else-if="i === 'background-image'">
                <BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template" />
            </div>

            </div>
        </template>

        <BackgroundVideo :componentItemContent="componentItem.content" />
        <BackgroundAudio :componentItemContent="componentItem.content" />
        <ForegroundAudio 
            :componentItemContent="componentItem.content" 
            :componentItemSampleContent="sampleContent['foreground-audio']"
        />

    </div>
</template>

<script>
    import BackgroundImage from '../BackgroundImage';
    import BackgroundVideo from '../BackgroundVideo';
    import BackgroundAudio from '../BackgroundAudio';
    import ForegroundAudio from '../ForegroundAudio.vue'
    import Repeater from '../Repeater';

	export default {
        
        components: {
            BackgroundImage,
            BackgroundVideo,
            Repeater,
            BackgroundAudio,
            ForegroundAudio
        },		
		
		name: 'ImageAndBodyCopy',
        
        props: ['componentItem', 'index', 'componentTemplates', "sampleContent"],

        computed:{
            getContentTemplate() {
                if(this.componentTemplates){
                    return JSON.parse(JSON.stringify(
                        this.componentTemplates.filter(item => item.template == 'image-and-body-copy')[0]
                    ));
                }else{
                    return null
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
    }

</style>